export default {
  data() {
    return {
      reset_pagination: {},
      reset_form: {},
      createTime: []
    };
  },
  created() {
    this.reset_pagination = this.pagination;
    this.reset_form = this.form;
    console.log('created');
  },
  methods: {
    copyText(val) {
      const input = document.createElement('input');
      document.body.appendChild(input);
      input.setAttribute('value', val);
      input.select();
      if (document.execCommand('copy')) {
        document.execCommand('copy');
        this.$notify({
          title: this.$t('status.success'),
          message: this.$t('channelTest.copy'),
          type: 'success'
        });
      } else {
        this.$notify({
          title: this.$t('status.error'),
          message: this.$t('status.error'),
          type: 'warning'
        });
      }
      document.body.removeChild(input);
    },
    resetTimer() {
      function getdate() {
        var date = new Date();
        var seperator1 = '-';
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var strDate = date.getDate();
        if (month >= 1 && month <= 9) {
          month = '0' + month;
        }
        if (strDate >= 0 && strDate <= 9) {
          strDate = '0' + strDate;
        }
        var currentdate = year + seperator1 + month + seperator1 + strDate;
        return currentdate;
      }
      this.createTime = [getdate() + ' 00:00:00', getdate() + ' 23:59:59'];
    },
    resetPagination() {
      //------------分页重置-------
      if (this.pagination && typeof this.pagination == 'object') {
        this.pagination = this.reset_pagination;
        console.log('分页重置', this.pagination);
      }
      //------------form分页重置-------
      if (this.form && typeof this.form == 'object') {
        if (this.form.no) {
          this.form.no = 1;
        }
        if (this.form.current) {
          this.form.current = 1;
        }
      }
    },
    async promptGoogleCode(submitAmount = null) {
      // <strong>这是 <i>HTML</i> 片段</strong>
      let _str = `${this.$t('orders.tip.googleCode')}`;
      if (submitAmount !== null) {
        _str = `
        ${this.$t('channelTest.label.amount')}: <strong style="color: red;">${Number(
          submitAmount
        ).toLocaleString()}</strong><br />
        ${this.$t('orders.tip.googleCode')}`;
      }
      return await this.$prompt(_str, this.$t('btns.hint'), {
        dangerouslyUseHTMLString: true,
        confirmButtonText: this.$t('btns.confirm'),
        cancelButtonText: this.$t('btns.cancel'),
        inputPattern: new RegExp(/^\d{6}$/, 'i'),
        inputErrorMessage: this.$t('merchantdeposit.rules.googleDynamicCaptcha.max'),
        closeOnClickModal: false
      }).catch((e) => {
        console.log(e);
      });
    },
    DeviceRowStyle({ row }) {
      return row.receivingMoneyStatus == '1' ? { background: 'rgb(119 228 119) !important' } : '';
    },
    DeviceCellStyle({ row, column }) {
      return column.property == 'receivedDayMoney' && row.receivedDayMoney > row.limits
        ? { color: 'red' }
        : '';
    },
    DeviceRowClass({ row }) {
      return row.receivingMoneyStatus == '1' ? 'moneysClass' : '';
    },
    async handleAccountExport({ api, formatParams }) {
      const { data } = await api(formatParams);
      if (data) {
        const BLOB = data;
        const fileReader = new FileReader();
        fileReader.readAsDataURL(BLOB);
        fileReader.onload = (event) => {
          // 处理load事件。该事件在读取操作完成时触发
          // 新建个下载的a标签，完成后移除。
          let a = document.createElement('a');
          a.download = `Merchant-WithdrawList${Number(new Date())}.xlsx`;
          a.href = event.target.result;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        };
      } else {
        this.$message.error(this.$t('status.error'));
      }
    },
    async changAmountLimit(row, callback = () => {}) {
      this.$prompt(this.$t('channelTest.label.amount'), this.$t('btns.hint'), {
        dangerouslyUseHTMLString: true,
        confirmButtonText: this.$t('btns.confirm'),
        cancelButtonText: this.$t('btns.cancel'),
        inputPattern: /^[0-9]*$/,
        inputErrorMessage: this.$t('merchantdetails.rules.amount.typeinteger'),
        closeOnClickModal: false,
        inputValidator: function (value) {
          if (!value) return false;
        }
      })
        .then(async ({ value }) => {
          const { data } = await this.$http.get(
            `/admin/updateMakeupLimit?amount=${value}&userId=${row.distributedId}`
          );
          if (data && data.code == 200) {
            callback();
          } else {
            this.$message.error(data.msg);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixin/base.js